import { useMutation } from '@tanstack/react-query';
import { patchNoteColor } from '@/services/notes/notesService';

interface PatchNoteColorVariables {
  userId: string;
  color: string | null;
}

export const usePatchNoteColor = () => {
  return useMutation({
    mutationFn: async ({ userId, color }: PatchNoteColorVariables) => patchNoteColor(userId, color),
  });
};
